import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ContentfulService } from '../contentful.service';
import { Entry } from 'contentful';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';

import { from } from 'rxjs/observable/from';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.css']
})
export class PartnersComponent implements OnInit {

  partner: Entry<any>[] = [];
  partnerContent: Entry<any>[] = [];
  menuOpen: boolean = false;
  partnerArr:any = [];
  partnerContentArr:any = [];
  siteUrl: any = environment.siteUrl;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private contentfulService: ContentfulService
  ) { }

  ngOnInit() {
      
      this.contentfulService.getPartners()
      .then((partner) => {
        this.partner = partner;
        let partnerData = this.partner;
        console.log(partnerData);

        for (var i = 0; i < partnerData.length; i++) {
          this.partnerArr.push({'id':partnerData[i].sys.id, 'title':partnerData[i].fields.name, 'imageLink':partnerData[i].fields.logo.fields.file.url, 'url':partnerData[i].fields.url});
        }

      });

      this.contentfulService.getPartnersData()
      .then((partnerContent) => {
        this.partnerContent = partnerContent;
        
        for (var i = 0; i < this.partnerContent.length; i++) {
          if(i == 0){
            this.partnerContentArr.push({'id':this.partnerContent[i].sys.id, 'title':this.partnerContent[i].fields.title, 'content':this.partnerContent[i].fields.content});
          }
        }

      });

      

      //this.faqId = this.route.snapshot.paramMap.get('id');
      
  }

  goToCourseDetailsPage(courseId) {
    this.router.navigate(['/news', courseId]);
  }

  toggleMenu(){
    this.menuOpen = !this.menuOpen;
  }


_returnHtmlFromRichText(richText) {
  if (richText === undefined || richText === null || richText.nodeType !== 'document') {
    return '<p>Error</p>';
  }
  /*
  const options = {
    renderMark: {
      [MARKS.BOLD]: text => `<custom-bold>${text}<custom-bold>`
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, next) =>
        `<custom-paragraph>${next(node.content)}</custom-paragraph>`
    }
  };

  const options = {
    renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: ({ data: { target: { fields }}}) =>
            `<img src="${fields.file.url}" height="${fields.file.details.image.height}" width="${fields.file.details.image.width}" alt="${fields.description}"/>`,
    },
};
*/
  return documentToHtmlString(richText);
}

createElementFromHTML(htmlString) {
  document.getElementById('iframeElement').innerHTML="";
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  div.setAttribute('id', 'elementId');
  //return div.firstChild; 
  document.getElementById('iframeElement').appendChild(div.firstChild); 
}

}





// WEBPACK FOOTER //
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/app/partners/partners.component.ts